export function isRangeFormat(format) {
    return 'range' in format;
}
export function isAliasFormat(format) {
    return 'alias' in format;
}
export function isExtendsNumberFormat(format) {
    return 'extends' in format && 'by' in format;
}
export function isExtendsDateFormat(format) {
    return 'extends' in format && 'by' in format;
}
//# sourceMappingURL=guards.js.map